"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoxAttribute = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _styles = require("./styles");

var _info = _interopRequireDefault(require("../../../assets/images/Icons/info.svg"));

var _TextField = _interopRequireDefault(require("@mui/material/TextField"));

var _Tooltip = _interopRequireWildcard(require("@mui/material/Tooltip"));

var _styles2 = require("@mui/material/styles");

var _variables = require("../../../global-files/variables");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["className"];

var BoxAttribute = function BoxAttribute(props) {
  var id = props.id,
      key = props.key,
      className = props.className,
      text = props.text,
      borderType = props.borderType,
      atributos = props.atributos,
      setAtributos = props.setAtributos,
      required = props.required,
      description = props.description;

  var handleInputChange = function handleInputChange(event) {
    var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
    setAtributos(function (prevAtributos) {
      return (0, _objectSpread3.default)((0, _objectSpread3.default)({}, prevAtributos), {}, (0, _defineProperty2.default)({}, name, value));
    });
  };

  var LightTooltip = (0, _styles2.styled)(function (_ref) {
    var className = _ref.className,
        props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, (0, _objectSpread3.default)((0, _objectSpread3.default)({}, props), {}, {
      classes: {
        popper: className
      }
    }));
  })(function (_ref2) {
    var theme = _ref2.theme;
    return (0, _defineProperty2.default)({}, "& .".concat(_Tooltip.tooltipClasses.tooltip), {
      backgroundColor: _variables.GlobalColors.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
      fontFamily: "".concat(_variables.FontFamily.Roboto, ", sans-serif")
    });
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
      id: id,
      className: className,
      borderType: borderType,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LightTooltip, {
        title: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "container-tooltip",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "container-tooltip",
            children: description
          })
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
          className: "",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            className: "icon",
            src: _info.default,
            alt: "iconInfo"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [text, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: required ? "required-text" : "",
          children: required ? "*" : ""
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
        hiddenLabel: true,
        name: props.id,
        value: atributos[props.id],
        onChange: handleInputChange,
        className: "caja-borde",
        variant: "outlined",
        size: "small",
        type: "number",
        required: required
      }, props.id)]
    }, key)
  });
};

exports.BoxAttribute = BoxAttribute;